module.exports = __webpack_public_path__ + "f4adb6d1d4ba3d62dda2b97b6bed497b.jpg";